import { compose } from 'shared/utils/function.utils';
import { getSuggestedProductsReducer } from './get-suggested-products';

export const extraReducers = compose(getSuggestedProductsReducer);

export { getSuggestedProducts } from './get-suggested-products';
